import { render, staticRenderFns } from "./proposalServiceWrapper.vue?vue&type=template&id=e93d8f5e"
import script from "./proposalServiceWrapper.vue?vue&type=script&lang=js"
export * from "./proposalServiceWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e93d8f5e')) {
      api.createRecord('e93d8f5e', component.options)
    } else {
      api.reload('e93d8f5e', component.options)
    }
    module.hot.accept("./proposalServiceWrapper.vue?vue&type=template&id=e93d8f5e", function () {
      api.rerender('e93d8f5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/proposalServiceWrapper.vue"
export default component.exports